
export const lastSearch = (value) => ({
    type: "LAST_SEARCH",
    value
})
